import React from 'react';
import clsx from 'clsx';

import styles from './Label.module.scss';

export default function Label({
	className,
	text,
	icon,
	variant,
	link,
	onClick,
	focus,
	noUppercase,
	hideText
}) {
	let labelContent = (
		<>
			{icon}{hideText ? null : text}
		</>
	);

	if (link) {
		labelContent = <a href={link}>{labelContent}</a>;
	}

	return text ? (
		<label
			className={clsx(
				styles.root,
				variant && styles[variant],
				focus && styles.focus,
				onClick && styles.action,
				noUppercase && styles.noUppercase,
				className && className
			)}
			onClick={onClick}
		>
			{labelContent}
		</label>
	) : null;
}
